import {useQuery} from 'react-query'
import Link from 'next/link'
import {useRouter} from 'next/router'
import type {JSX} from 'react'
import {useFetchBreadcrumbs} from '@/_new-code/services/breadcrumbs/client'
import type {
	AdvancedPageTemplateContentItem,
	Tersed,
} from '@/_new-code/services/kontent-ai/types'
import {Breadcrumbs as ClBreadcrumbs} from '../breadcrumbs'

interface HeaderBreadcrumbsProps {
	page: Tersed<AdvancedPageTemplateContentItem>
}

export const HeaderBreadcrumbs = ({
	page,
}: HeaderBreadcrumbsProps): JSX.Element => {
	const pageKontentItemId = page.system.id
	const {locale = '', asPath} = useRouter()
	const {isLoading, data} = useQuery({
		queryKey: [
			'breadcrumbs',
			{
				pageId: pageKontentItemId,
				locale,
				pageUrl: asPath.split('?', 1)[0],
			},
		],
		queryFn: useFetchBreadcrumbs,
		cacheTime: 15 * (60 * 1000),
		staleTime: Infinity,
	})

	if (isLoading || !Array.isArray(data)) return <div />

	return (
		<div className="border-b border-solid bg-white">
			<div className="container-wide">
				<ClBreadcrumbs>
					{data.map((crumb) => (
						<Link
							className="mr-2 cursor-pointer"
							href={`/${locale}${
								crumb.url === '/' ? '' : crumb.url
							}`}
							key={crumb.id}
						>
							{crumb.breadcrumbText || crumb.title}
						</Link>
					))}
				</ClBreadcrumbs>
			</div>
		</div>
	)
}
